import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import PageHeader from './common/PageHeader';

const tabs = [
    { name: '마켓', path: '/marketplace' },
    { name: '장바구니', path: '/cart' },
    { name: '구매내역', path: '/my-orders' },
];

function MarketplaceLayout({ children }) {
    const location = useLocation();
    const navigate = useNavigate();

    const activeTab = tabs.find(t =>
        location.pathname === t.path || location.pathname.startsWith(t.path + '/')
    )?.path || '/marketplace';

    return (
        <div>
            <PageHeader icon={ShoppingBag} title="DC마켓">
                <div style={styles.tabBar}>
                    {tabs.map(tab => {
                        const isActive = activeTab === tab.path;
                        return (
                            <button
                                key={tab.path}
                                onClick={() => navigate(tab.path)}
                                style={{
                                    ...styles.tab,
                                    color: isActive ? '#4f46e5' : '#64748b',
                                    borderBottom: isActive ? '2.5px solid #4f46e5' : '2.5px solid transparent',
                                    fontWeight: isActive ? 600 : 400,
                                }}
                            >
                                {tab.name}
                            </button>
                        );
                    })}
                </div>
            </PageHeader>
            {children}
        </div>
    );
}

const styles = {
    tabBar: {
        display: 'flex',
        gap: 4,
        marginTop: 4,
    },
    tab: {
        padding: '8px 20px 10px',
        fontSize: 14,
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        transition: 'color 0.15s, border-color 0.15s',
    },
};

export default MarketplaceLayout;
